import React, { useState } from 'react';
import NumberSelector from '../components/NumberSelector';
import { Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { isInCart } from '../selectors';
import { addToCart } from '../actions/cartActions';

const AddToCart = ({ sku, history }) => {
    const [number, setNumber] = useState(1);
    const inCart = useSelector((state) => isInCart(state, sku));

    const dispatch = useDispatch();
    const handleAddToCart = () => {
        dispatch(addToCart(sku, number, history));
    };
    return (
        <div style={{ display: 'flex', marginTop: '1rem', flexWrap: 'wrap' }}>
            <Button
                variant="contained"
                style={{ marginRight: '1rem' }}
                onClick={handleAddToCart}
                disabled={inCart}
            >
                {inCart ? 'Added To Cart' : 'Add to Cart'}
            </Button>
            <NumberSelector
                disabled={inCart}
                number={number}
                setNumber={setNumber}
            />
        </div>
    );
};

export default AddToCart;
